export const MODAL_KEYS = {
  CLOSE_PARTY: 'CLOSE_PARTY',
  CROP_SELECTION: 'CROP_SELECTION',
} as const;
